import _ from 'lodash';
import uuid from 'uuid/v1';
import Constants from '../../../common/Constants';
import { RoundRobinOption, WinRiskType, WagerMyBetMap, BetType } from '../../../common/Foundation';
import Utils from '../../../common/Utils';
import AlertComponentAction from '../../BaseComponent/AlertComponent/AlertComponentAction';
import BetslipAction from '../BetslipAction';
import ToastGeneratorAction from '../../BaseComponent/ToastGeneratorComponent/ToastGeneratorAction';
import MbAsiaBetslipActions from './MbAsiaBetslipActions'
import { toJS } from 'mobx';
import { EVENT } from '../../../common/events/listEvents';
import { wagerSelectionMap } from '../../MyBetComponent/constant';

export default class MbNewAsiaBetslipActions {
  static initStores(NewBetslipStore, sportsStore) {
    this.NewBetslipStore = NewBetslipStore
    this.SportsStore = sportsStore
  }

  static initTranslation(translate) {
    this.translate = translate
  }

  static initParlayDefaultStake(isRemove) { //// need to use reuselection 
    const { defaultStake, enableDefaultStake } = this.SportsStore.options;
    const { selectedRoundRobins, stake } = this.NewBetslipStore.asiaParlayData
    const selectedRRo = selectedRoundRobins.length && !isRemove ? selectedRoundRobins : [RoundRobinOption.PARLAY]
    const initStake = stake ? stake : enableDefaultStake ? defaultStake : ''
    this.NewBetslipStore.setAsiaParlayData({ stake: initStake, selectedRoundRobins: selectedRRo });
  }

  static invalidOddsFromatHandle() {
    AlertComponentAction.openAlertCallBack(
      this.translate(`errors:${Constants.BET_ERROR_CODE.INVALID_ODDS_FORMAT}`),
      () => { MbAsiaBetslipActions.updateMaxBetPreferenceSettingBase() }, 'alert-invalid-odds-format',
      this.translate("Selection unavailable"), false);
  }

  static initTeaserDefaultStake() {
    const { defaultStake, enableDefaultStake } = this.SportsStore.options;
    const { stake } = this.NewBetslipStore.asiaTeaserData;
    const initStake = stake ? stake : enableDefaultStake ? defaultStake : ''
    this.NewBetslipStore.setAsiaTeaserData({ stake: initStake });
  }

  static getSingleSelectionInfo(manualRefresh, autoRefresh) {
    if (!this.NewBetslipStore.asiaSingleSelection.length) {
      return
    }
    if(!autoRefresh) {
      this.NewBetslipStore.setLoading(true)
      this.NewBetslipStore.setValidateWarning('')
    }
    const { oddsFormat } = this.SportsStore.options
    const data = this.NewBetslipStore.asiaSingleSelection.map(item => {
      return {
        selectionId: item.selection,
        oddsId: item.id,
        oddsSelectionsType: item.oddsSelectionsType
      }
    })

    const currentOddsId = data[0] ? data[0].oddsId : undefined
    let payload = BetslipAction.buildNormalBetSelectionPayload(data, oddsFormat)

    BetslipAction.getAllOddsSelection(payload).then(response => {
      if (response) {
        if (response.error) {
          // remove invalid section
          const validSelections = this.NewBetslipStore.asiaSingleSelection.filter(selection => selection.id !== currentOddsId) || []
          this.NewBetslipStore.setAsiaSingleSelection(validSelections)

          AlertComponentAction.openAlert(this.translate('errors:' + response.error));
          this.NewBetslipStore.setLoading(false)
          return;
        }
        let res = response[0]
        /**
          *  Max Bet Reference BASE
          *  CASE: Agent setting => In-session User click Normal Odds
          * 
          * */
        if (res) {
          if (BetslipAction.isInValidStatus(res.status)) {
          } else {
            // Do not update data when refresh
            const isInitSingleData = !autoRefresh && !manualRefresh
            this.initSingleDefaultStake(this.NewBetslipStore.asiaSingleInputs, response, isInitSingleData)
          }
        }
        // Filter data and sorting data by ordinal position
        const data = this.NewBetslipStore.asiaSingleSelection
          .map((selection) =>
            response.find((res) => res.oddsId === selection.id)
          )
          .filter((item) => !!item);

        const keepBet = this.NewBetslipStore.asiaNormalBetItem.filter(item => BetslipAction.checkSuccessBet(item.status));
        const newBet = [...keepBet, ...data];
        const asiaSingleSelection = this.NewBetslipStore.asiaSingleSelection;

        oddsFormat !== this.SportsStore.getPreviousOddsFormat && this.updateOddsByOddsFormat(oddsFormat, asiaSingleSelection, newBet, false);
        this.NewBetslipStore.updateAsiaNormalBetItem(newBet);
        this.NewBetslipStore.updateStartCountdown(true);
        this.NewBetslipStore.updateResetCountdown(true);
        !autoRefresh && this.NewBetslipStore.setLoading(false);
      }
    })
  }

  // Update odds change follow the odds format
  static updateOddsByOddsFormat(oddsFormat, selections, responseSelections, isParlay) {
    const selectionsHasOddsChange = BetslipAction.getSelectionsHasOddsChange(responseSelections);
    if (selectionsHasOddsChange.length > 0 && selections.length > 0) {
      responseSelections.forEach(item => {
        const selectionIndex = selections.findIndex(selection => isParlay ? selection.legId === item.legId : (selection.id === item.oddsId));
        if (selectionIndex < 0) return;
        this.NewBetslipStore.updateSelectionOdds(BetslipAction.convertOddsByOddsFormat(selections[selectionIndex].odds, this.SportsStore.previousOddsFormat, oddsFormat), selectionIndex);
      });
    }
    this.SportsStore.updatePreviousOddsFormat(oddsFormat);
  }

  static getValidOddsSelected(oddsSelected, selections) {
    const [eventId, period, betType, ...others] = oddsSelected.id.split('|')
    let numberPosition = 1;
    if(Number(betType) === BetType.OUTRIGHT) {
      numberPosition = 2
      oddsSelected.selection += '0' // outright bet always has team type = 0
    }
    const index = selections.findIndex(selection => {
      const [
        eventIdSelection,
        periodSelection,
        betTypeSelection,
        ...othersSelection
      ] = selection.id.split('|');
      return eventId === eventIdSelection &&
        period === periodSelection &&
        betType === betTypeSelection &&
        Math.abs(Number(others[others.length - numberPosition]))
          === Math.abs(Number(othersSelection[othersSelection.length - numberPosition]))
    })

    const result = JSON.parse(JSON.stringify(selections));
    if (index >= 0) {
      if (result[index].id !== oddsSelected.id) {
        result.push(oddsSelected);
      }
      result.splice(index, 1); 
      return result;
    }

    return [...result, {...oddsSelected}]
  }

  static getParlaySelectionInfo(isRefresh) {
    const { getParlaySelections, isReuseSelection, asiaParlayTicket, asiaSingleSelection } = this.NewBetslipStore

    if (!getParlaySelections.length) {
      this.NewBetslipStore.asiaParlayTicket.legs && this.NewBetslipStore.updateAsiaParlayTicket({})
      return
    }

    const { oddsFormat } = this.SportsStore.options;
    const isRemove = asiaParlayTicket && (asiaParlayTicket.legs || []).length > getParlaySelections.length;

    this.NewBetslipStore.setLoading(true)
    if (isRemove) {
      const removedLeg = asiaParlayTicket.legs.find(ticket => !getParlaySelections.some(sel => ticket.legId === sel.legId))
      const deletePayload = MbAsiaBetslipActions.buildAsiaParlayBetSelectionPayload(getParlaySelections, oddsFormat, asiaParlayTicket.ticketId)

      BetslipAction.removeParlayBetSelection(deletePayload, removedLeg.legId).then(res => {
        if (res) {
          if (res.error) {
            AlertComponentAction.openAlertCallBack(
              this.translate('errors:' + res.error),
              () => AlertComponentAction.closeAlert()
            )
          } else {
            this.NewBetslipStore.updateAsiaParlayTicket(res)
            MbNewAsiaBetslipActions.initParlayDefaultStake(isRemove);
          }
          this.NewBetslipStore.setLoading(false)
        }
      })
    }
    else {
      const payload = MbAsiaBetslipActions.buildAsiaParlayBetSelectionPayload(getParlaySelections.map(sel => {
        sel.legId = uuid();
        return sel;
      }), oddsFormat)
      BetslipAction.getParlayOddsSelection(payload).then(res => {
        if (res) {
          if (res.error) {
            AlertComponentAction.openAlertCallBack(
              this.translate('errors:' + res.error),
              () => AlertComponentAction.closeAlert()
            )
          } else {
            if (!isRefresh) {
              MbNewAsiaBetslipActions.initParlayDefaultStake();
              if (isReuseSelection) {
                MbAsiaBetslipActions.clearReuseSelection();
              }
            }
          }

          (res.legs || []).forEach(leg => {
            const filterSelection = getParlaySelections.find(selection => selection.legId === leg.legId)
            if (filterSelection) {
              leg.parlayRestriction = filterSelection.parlayRestriction
            }
          })
          this.NewBetslipStore.updateAsiaParlayTicket(res);
          this.NewBetslipStore.setLoading(false)
          oddsFormat !== this.SportsStore.getPreviousOddsFormat && this.updateOddsByOddsFormat(oddsFormat, asiaSingleSelection, res.legs, true);
        }
      });
    }
  }

  static updateParlayPendingBetsToAcceptedBets(bets) {
    const parlayBetSuccessRes = this.NewBetslipStore.parlayBetSuccessRes;
    const { pendingBets, roundRobinOptions, legs} = parlayBetSuccessRes;

    const idMap = WagerMyBetMap[pendingBets && pendingBets.length > 0 ? 'wagerMasterId' : 'wagerId']
    // Filter the bets array from my-bets service by status, then filter the result by betId and rroLegs.
    const filterByStatus = (bets, pendingBet, status) => {
      return bets
        .filter(bet => bet[WagerMyBetMap.status] === status)
        .filter(bet => pendingBet.betId === bet[idMap])
        .filter(bet => pendingBet.rroLegs === bet[WagerMyBetMap.wagerSelections].length);
    }

    if (pendingBets) {
      // accepted bets
      const acceptedBets = pendingBets
        .map(pendingBet => {
          const acceptedFilter = filterByStatus(bets, pendingBet, Constants.WAGER_STATUS.OPEN);
          if (acceptedFilter.length > 0) {
            roundRobinOptions[0].odds = acceptedFilter.reduce((odds, bet) => {
              return odds + Utils.convertStakeToNumber(bet[WagerMyBetMap.odds]);
            }, 0);
            acceptedFilter[0][WagerMyBetMap.wagerSelections].forEach(item => {
              const legIndex = legs.findIndex(leg => leg.eventId === item[wagerSelectionMap.eventId]);
              if (legIndex < 0) return;
              legs[legIndex].odds = item[wagerSelectionMap.odds];
              legs[legIndex].handicap = item[wagerSelectionMap.handicap];
            });
            return {
              ...pendingBet,
              status: Constants.ACCEPTED,
              risk: acceptedFilter.reduce((totalRisk, bet) => {
                return totalRisk + Utils.convertStakeToNumber(bet[WagerMyBetMap.risk]);
              }, 0),
              win: acceptedFilter.reduce((totalWin, bet) => {
                return totalWin + Utils.convertStakeToNumber(bet[WagerMyBetMap.win]);
              }, 0),
            }
          }
          return null;
        })
        .filter(pendingBet => pendingBet);

      // getting rejected bets if there are no accepted bets
      const rejectedBets = acceptedBets.length === 0
        ? pendingBets
          .map(pendingBet => {
            const rejectedFilter = filterByStatus(bets, pendingBet, Constants.WAGER_STATUS.CANCELLED);
            if (rejectedFilter.length > 0) {
              return {
                ...pendingBet,
                status: Constants.PROCESSED_WITH_ERROR
              };
            }
            return null;
          })
          .filter(pendingBet => pendingBet)
        : [];

      if (acceptedBets.length > 0) {
        // update from pendingBets to acceptedBets
        parlayBetSuccessRes.status = Constants.ACCEPTED;
        parlayBetSuccessRes.acceptedBets = acceptedBets;
        delete parlayBetSuccessRes['pendingBets'];
        this.NewBetslipStore.updateParlayBetSuccessRes(parlayBetSuccessRes);
        this.renderParlayToastSuccess()

        //TODO: show toast success
      }

      if (rejectedBets.length > 0) {
        // update from pendingBets to rejectedBets
        parlayBetSuccessRes.status = Constants.PROCESSED_WITH_ERROR;
        parlayBetSuccessRes.acceptedBets = rejectedBets;
        delete parlayBetSuccessRes['pendingBets'];
        this.NewBetslipStore.updateParlayBetSuccessRes(parlayBetSuccessRes);
        this.renderParlayToastError('Your bet has been rejected.')

        //TODO: show toast error
      }
    }
  }

  static getTeaserSelectionInfo() {

    if (!this.NewBetslipStore.asiaTeaserSelections.length) {
      // Clear ticket data for the case deselecting all selections
      this.NewBetslipStore.asiaTeaserTicket.legs && this.NewBetslipStore.updateAsiaTeaserTicket({})
      return
    }

    const { oddsSelections, asiaTeaserSelections, asiaTeaserTicket, oddsReuseSelections } = this.NewBetslipStore;
    if(!_.isEqual([...oddsReuseSelections],[...oddsSelections])) {
      this.NewBetslipStore.setOddsReuseSelections([...oddsSelections])
    }
    const { oddsFormat } = this.SportsStore.options
      this.NewBetslipStore.setAsiaTeaserReuseSelections(this.NewBetslipStore.asiaTeaserSelections);
    this.NewBetslipStore.setLoading(true)

      const teaserId =
        (asiaTeaserSelections || []).length > 0
          ? _.last(asiaTeaserSelections.find((sel) => sel).id.split("|"))
          : "";
      if (teaserId) {
        const newAsiaTeaserSelections = asiaTeaserSelections.map((sel) => ({
          id: sel.id,
          legId: uuid(),
          selection: sel.selection,
          odds: sel.odds,
        }));
        const payload = MbAsiaBetslipActions.buildAsiaTeaserBetSelectionPayload(newAsiaTeaserSelections, oddsFormat, teaserId, asiaTeaserTicket.ticketId)

        this.NewBetslipStore.updateTeaserBetPayload(payload);
        BetslipAction.getTeaserOddsSelection(payload).then(res => {
          if (res) {
            if (res.error) {
              AlertComponentAction.openAlertCallBack(
                this.translate('errors:' + res.error),
                () => AlertComponentAction.closeAlert()
              )
              return
              }

              this.mergeTeaserSelection(oddsSelections, res)
              MbNewAsiaBetslipActions.initTeaserDefaultStake()
              this.NewBetslipStore.updateAsiaTeaserTicket(res);
              this.NewBetslipStore.setLoading(false)
          }
        })
    }
  }

  static updateSinglePendingBetsToAcceptedBets(res) {
    const acceptedStatuses = [Constants.WAGER_STATUS.OPEN, Constants.WAGER_STATUS.CANCELLED]
    const { newAsiaSingleData, asiaNormalBetItem, reuseAsiaNormalBetItem } = this.NewBetslipStore
    const remainingIds = []
    if (res) {
      for (let item of res) {
        for (let bet of newAsiaSingleData.pendingBets) {
          if (item && item[WagerMyBetMap.wagerId] === bet) {
            if (acceptedStatuses.includes(item[WagerMyBetMap.status])) {
              const indexAsiaNB = _.findIndex(asiaNormalBetItem, (e) => e.wagerId === item[WagerMyBetMap.wagerId])
              const indexReuseAsiaNB = _.findIndex(reuseAsiaNormalBetItem, (e) => e.wagerId === item[WagerMyBetMap.wagerId])
              const status = item[WagerMyBetMap.status]
              const win = item[WagerMyBetMap.win]
              const risk = item[WagerMyBetMap.risk]
              let selectionId = ''
              if (indexAsiaNB > -1) {
                const updatedItem = { ...asiaNormalBetItem[indexAsiaNB], status, win, risk }
                this.NewBetslipStore.updateAsiaNormalItem(updatedItem, indexAsiaNB)
              }
              if (indexReuseAsiaNB > -1) {
                const reuseSingleBet = reuseAsiaNormalBetItem[indexReuseAsiaNB]
                selectionId = reuseSingleBet.selectionId
              }

              if (item[WagerMyBetMap.status] === Constants.WAGER_STATUS.OPEN) {
                this.renderSingleToast(selectionId, Constants.TOAST.NEW_ACCEPTED_BET_MESSAGE, Constants.TOAST.NEW_TOAST_CLASS_ACTIVE, Constants.TOAST.TOAST_CLASS_ACTIVE, true)
              }
              else {
                this.renderSingleToast(selectionId, Constants.TOAST.NEW_UNACCEPTED_BET_MESSAGE, Constants.TOAST.NEW_TOAST_CLASS_ERROR, Constants.TOAST.TOAST_CLASS_ERROR, true)
              }
            } else {
              remainingIds.push(bet)
            }
          }
        }
      }
    }
    this.NewBetslipStore.updatePendingBets(remainingIds)
  }

  static placeSingleBet(startCheckPendingAcceptance, scrollToBottom) {
    AlertComponentAction.closeAlert();
    this.NewBetslipStore.setLoading(true)
    this.NewBetslipStore.updateStartCountdown(false)

    const { asiaSingleSelection, newAsiaSingleData, asiaNormalBetItem, asiaSingleInputs, reuseAsiaNormalBetItem } = this.NewBetslipStore
    const { normalAcceptBetterOdds, pendingBets } = newAsiaSingleData;
    const winRiskOption = this.NewBetslipStore.getWinRiskOption;
    const { oddsFormat } = this.SportsStore.options;

    const payload = BetslipAction.buildNewAsiaSingleBetPayload(
      normalAcceptBetterOdds,
      oddsFormat,
      asiaNormalBetItem,
      asiaSingleInputs,
      winRiskOption
    );
    if (!payload.selections.length) {
      return;
    }
    BetslipAction.placeNormalBets(payload).then((res) => {
      this.NewBetslipStore.setLoading(false)
      this.NewBetslipStore.setValidateWarning('')
      if (res) {
        const { errorCode, response, errorMessage } = res.data;
        if (errorCode) {
          const msg = this.translate("errors:" + errorCode, { 0: errorMessage });
          if (
            errorCode === Constants.RESPONSIBLE_LIMIT_EXCEEDED_RISK ||
            errorCode === Constants.RESPONSIBLE_LIMIT_EXCEEDED_LOSS
          ) {
            this.NewBetslipStore.updateAsiaSingleData("stake", errorMessage);
          }
          AlertComponentAction.openAlert(msg, "asia_betslip_alert");
          return;
        }

        if (response && response.length) {
          if (Constants.BET_ERROR_CODE.INVALID_ODDS_FORMAT === response[0].errorCode) {
            this.invalidOddsFromatHandle();
            return;
          }
          else {
            let singleBets = JSON.parse(JSON.stringify(asiaNormalBetItem))
            let oddsSelection = JSON.parse(JSON.stringify(asiaSingleSelection))
            const stakeInputs = JSON.parse(JSON.stringify(asiaSingleInputs))
            this.NewBetslipStore.updateReuseAsiaSingleInputs(asiaSingleInputs)

            response.forEach((res, index) => {
              const betIndex = singleBets.findIndex(item => {
                return item.oddsId === res.oddsId;
              })
              if (betIndex > -1) {
                if (res.status === Constants.ACCEPTED || res.status === Constants.PENDING_ACCEPTANCE) {
                  const { status, wagerId } = res;
                  singleBets[betIndex] = {
                    ...singleBets[betIndex],
                    wagerId,
                    status
                  }
                  
                  // Remove odd selection and odd data after bet successfully
                  oddsSelection = oddsSelection.filter(sel => sel.id !== res.oddsId)
                  delete stakeInputs[res.oddsId]

                  if (status === Constants.PENDING_ACCEPTANCE) {
                    const newPendingBets = pendingBets
                    newPendingBets.push(wagerId)
                    this.NewBetslipStore.updatePendingBets(newPendingBets)
                  }
                  else {
                    const { psBetVO: { risk, win } } = res;
                    singleBets[betIndex] = {
                      ...singleBets[betIndex],
                      risk,
                      win
                    }
                    this.renderSingleToast(response[index].selectionId, Constants.TOAST.NEW_ACCEPTED_BET_MESSAGE, Constants.TOAST.NEW_TOAST_CLASS_ACTIVE, Constants.TOAST.TOAST_CLASS_ACTIVE, false)
                  }
                }
                else if (res.status === Constants.PROCESSED_WITH_ERROR) {
                  const jsonDetail = res.jsonString ? JSON.parse(res.jsonString).bets.find(bet => {
                    return bet.uniqueRequestId === res.uniqueRequestId;
                  }) : undefined

                  let updateData = singleBets[betIndex]
                  if (res.errorCode === Constants.LINE_CHANGED && jsonDetail) {
                    let isGenerateNewSelectionId = true
                    updateData = {
                      ...updateData,
                      status: Constants.ODDS_CHANGE,
                      lineId: jsonDetail.lineId,
                      maxRiskStake: jsonDetail.maxRiskStake,
                      maxWinStake: jsonDetail.maxWinStake,
                      minRiskStake: jsonDetail.minRiskStake,
                      minWinStake: jsonDetail.minWinStake
                    }

                    if (singleBets[betIndex].altLineId) {
                      updateData = {
                        ...updateData,
                        altLineId: jsonDetail.altLineId
                      }
                    }
                    if (Number(singleBets[betIndex].odds) !== Number(jsonDetail.price)) {
                      updateData = {
                        ...updateData,
                        odds: jsonDetail.price.toString(),
                        oldOdds: singleBets[betIndex].odds
                      }
                      const currentInput = stakeInputs[singleBets[betIndex].oddsId]

                      currentInput.odds = updateData.odds
                      let winRiskOption = currentInput.winRiskOption
                      if (oddsFormat !== oddsFormat.AM && oddsFormat !== oddsFormat.EU) {
                        winRiskOption = currentInput.odds > 0 ? WinRiskType.RISK : WinRiskType.WIN
                      }
                      if (winRiskOption === WinRiskType.RISK) {
                        const riskVal = Utils.convertStakeToNumber(currentInput.riskVal)
                        currentInput.winVal = BetslipAction.calculateToWin(riskVal, updateData.odds, oddsFormat, WinRiskType.RISK, currentInput.betType)
                      } else if (winRiskOption === WinRiskType.WIN) {
                        const winVal = Utils.convertStakeToNumber(currentInput.winVal)
                        currentInput.riskVal = BetslipAction.calculateToRisk(winVal, updateData.odds, oddsFormat, WinRiskType.WIN)
                      }
                      currentInput.winRiskOption = winRiskOption
                      isGenerateNewSelectionId = false

                    }
                    if (isGenerateNewSelectionId) {
                      // generate new selection id for submit again
                      const currentSelectionId = singleBets[betIndex].selectionId.split('|');
                      const newSelectionId = BetslipAction.updateSelectionId(currentSelectionId, updateData);
                      updateData = {
                        ...updateData,
                        selectionId: newSelectionId
                      }

                      const selectionIndex = oddsSelection.findIndex(item => {
                        return item.oddsId === res.oddsId;
                      })
                      if (selectionIndex > -1) {
                        const newSelectionId = oddsSelection[selectionIndex].selectionId.split('|')
                        newSelectionId[0] = updateData.lineId
                        oddsSelection[selectionIndex].selectionId = newSelectionId.join('|')
                      }
                    }
                  } else if (res.errorCode === Constants.EVENT_OFFLINE) {
                    updateData = {
                      ...updateData,
                      status: Constants.UNAVAILABLE,
                    }
                  }
                  else if (res.errorCode === Constants.MAX_BET_EXCEEDED) {
                    // update win/risk value
                    const currentInput = stakeInputs[res.oddsId]
                    if (currentInput.winRiskOption === WinRiskType.RISK) {
                      currentInput.riskVal = Utils.convertStakeToNumber(res.errorData)
                      currentInput.winVal = BetslipAction.calculateToWin(currentInput.riskVal, updateData.odds, oddsFormat, WinRiskType.RISK, currentInput.betType)
                    } else if (currentInput.winRiskOption === WinRiskType.WIN) {
                      currentInput.winVal = Utils.convertStakeToNumber(res.errorData)
                      currentInput.riskVal = BetslipAction.calculateToRisk(currentInput.winVal, updateData.odds, oddsFormat, WinRiskType.WIN)
                    }
                    updateData = {
                      ...updateData,
                      status: Constants.MAX_BET_EXCEEDED,
                    }
                  }
                  else if (res.errorCode) {
                    updateData = {
                      ...updateData,
                      status: res.errorCode,
                      errorData: jsonDetail
                    }
                  }
                  singleBets[betIndex] = updateData
                }
              }
            })

            // Reset stake per bet, accept better odds after all bet are successfully 
            if(!oddsSelection.length) {
              this.NewBetslipStore.updateNewAsiaSingleData("outRightAcceptBetterOdds", false)
              this.NewBetslipStore.updateNewAsiaSingleData("normalAcceptBetterOdds", false)
              this.NewBetslipStore.updateNewAsiaSingleData("stakePerBet", "")
            } 
            this.NewBetslipStore.updateAsiaNormalBetItem(singleBets)
            this.NewBetslipStore.updateReuseAsiaNormalBetItem([...reuseAsiaNormalBetItem, ...singleBets])
            this.NewBetslipStore.updateSingleStakeInputs(stakeInputs)
            this.NewBetslipStore.setAsiaSingleSelection(oddsSelection)
            pendingBets.length && startCheckPendingAcceptance(Constants.ASIA_BETSLIP_TYPES.SINGLE)
            
            // Scroll to unsubmitted bet
            if(oddsSelection.length) scrollToBottom()
          }
        }

      } else {
        const msg = this.translate("errors:INTERNAL_ERROR");
        AlertComponentAction.openAlert(msg, "asia_betslip_alert");
      }
    });
  }

  static placeParlaysBet(startCheckPendingAcceptance) {
    AlertComponentAction.closeAlert()
    this.NewBetslipStore.setLoading(true);
    this.NewBetslipStore.resetAttentionData();
    const { asiaParlayTicket, asiaParlayData } = this.NewBetslipStore
    const { oddsFormat } = this.SportsStore.options
    const { stake, selectedRoundRobins } = asiaParlayData
    const { ticketId, legs } = asiaParlayTicket
    const selectedRROs = legs && legs.length === 2 ? [RoundRobinOption.PARLAY] : selectedRoundRobins

    const payload = BetslipAction.buildParlayBetPayload(ticketId, stake, oddsFormat, true, selectedRROs)

    BetslipAction.placeParlayBets(payload).then(res => {
      this.NewBetslipStore.setLoading(false)
      if (res) {
        const { errorCode, response, errorMessage } = res.data
        if (errorCode) {
          if (errorCode === 'RESPONSIBLE_LIMIT_EXCEEDED_RISK' || errorCode === 'RESPONSIBLE_LIMIT_EXCEEDED_LOSS') {
            this.NewBetslipStore.updateAsiaParlayData('stake', errorMessage)
          }
          let errorMsg
          if ('INVALID_ROUND_ROBIN_OPTIONS' === errorCode) {
            errorMsg = this.translate('errors:MINIMUM_ROUND_ROBIN_OPTIONS')
          } else if ('BETTING_BUDGET_EXCEEDED' === errorCode) {
            errorMsg = this.translate('errors:' + errorCode, { 0: errorMessage });
          } else {
            errorMsg = this.translate('errors:' + errorCode)
          }

          AlertComponentAction.openAlert(errorMsg, 'asia_betslip_alert')
          return
        }

        const status = response && response.length ? response[0].status : undefined
        switch (status) {
          case "PROCESSED_WITH_ERROR":
            this.handleParlaysErrorResponse(response[0]);
            break;
          case "ACCEPTED":
          case "PENDING_ACCEPTANCE":
            this.handleParlaysSuccessResponse(response, selectedRROs, startCheckPendingAcceptance);
            this.NewBetslipStore.updateInitStakeReuse(stake);
            break;
          default:
            this.handleParlaysErrorResponse(response[0]);
            break;
        }
      }
      else {
        const msg = this.translate('errors:INTERNAL_ERROR')
        AlertComponentAction.openAlert(msg, 'asia_betslip_alert')
      }
    })
  }

  static handleParlaysSuccessResponse(response, selectedRROs, startCheckPendingAcceptance) {
    const { asiaParlayTicket, asiaParlayData, asiaSingleSelection, getParlaySelections } = this.NewBetslipStore
    const status = response && response.length ? response[0].status : undefined
    const parlayBetSuccessRes = JSON.parse(JSON.stringify(asiaParlayTicket))
    const { roundRobinOptions } = parlayBetSuccessRes;
    const bets = [Constants.ACCEPTED].includes(status)
      ? selectedRROs.map(rro => {
        const rroDetail = roundRobinOptions.filter(r => r.roundRobinOption === rro)[0] || {};
        const acceptedBets = response.filter(bet => bet.parlayBet.legs.length === rroDetail.rroLegs);
        if (acceptedBets.length > 0) {
          const win = acceptedBets.length === 1 ? acceptedBets[0].parlayBet.win : acceptedBets.reduce((totalWin, bet) => { return totalWin + bet.parlayBet.win }, 0)
          const risk = acceptedBets.length === 1 ? acceptedBets[0].parlayBet.risk : acceptedBets.reduce((totalRisk, bet) => { return totalRisk + bet.parlayBet.risk }, 0)

          return {
            betId: acceptedBets[0].betId,
            win,
            risk,
            roundRobinOption: rro,
            status: Constants.ACCEPTED
          }
        }
        return null;
      }).filter(bet => bet)
      : selectedRROs.map(rro => {
        const rroDetail = roundRobinOptions.filter(r => r.roundRobinOption === rro)[0] || {};
        return {
          betId: response[0].betId,
          roundRobinOption: rro,
          rroLegs: rroDetail.rroLegs,
          status: Constants.PENDING_ACCEPTANCE
        }
      });

    parlayBetSuccessRes[
      [Constants.ACCEPTED].includes(status)
        ? 'acceptedBets'
        : 'pendingBets'
    ] = bets;

    parlayBetSuccessRes.status = status;
    this.NewBetslipStore.updateParlayBetSuccessRes(parlayBetSuccessRes)
    this.NewBetslipStore.updateReuseAsiaParlayBetItem(parlayBetSuccessRes)
    this.NewBetslipStore.updateReuseAsiaParlayData(asiaParlayData)
    this.NewBetslipStore.setAsiaSingleSelection(_.difference(asiaSingleSelection, getParlaySelections))
    this.NewBetslipStore.resetAsiaParlayData()
    this.NewBetslipStore.updateAsiaNormalBetItem([])
    parlayBetSuccessRes.acceptedBets && parlayBetSuccessRes.acceptedBets.length && this.renderParlayToastSuccess()
    parlayBetSuccessRes.pendingBets && parlayBetSuccessRes.pendingBets.length && startCheckPendingAcceptance(Constants.ASIA_BETSLIP_TYPES.PARLAY)
  }

  // Todo: pending review before remove
  static updateParlayTicket() {
    let asiaParlayTicket = this.NewBetslipStore.asiaParlayTicket
    const { ticketId, legs } = asiaParlayTicket
    const { oddsFormat } = this.SportsStore.options
    let updateLegs = legs.map(l => { return { legId: l.legId, selectionId: l.selectionId } })
    const params = BetslipAction.buildParlayUpdateTicketPayload(ticketId, oddsFormat, updateLegs)
    let msgCode = null

    BetslipAction.updateParlayTicket(params).then(res => {
      if (res) {
        const { updatedTickets } = res
        let updatedLegs = legs.map(leg => {
          let matchedLeg = updatedTickets.filter(l => l.legId === leg.legId)[0]
          const { status } = matchedLeg

          leg.status = status

          if (matchedLeg.errorCode === 'LINE_CHANGED') {
            msgCode = 'LINE_CHANGED'
          }
          switch (status) {
            case Constants.ODDS_CHANGE:
              if (Number(matchedLeg.odds) !== Number(leg.odds)) {
                leg.odds = matchedLeg.odds
                msgCode = 'BET_LINE_CHANGED'
              }
              break
            case Constants.UNAVAILABLE:
              leg.errorCode = Constants.UNAVAILABLE
              leg.errorMessage = this.translate('errors:' + Constants.UNAVAILABLE_MESSAGE)
              break
            case Constants.LINE_CHANGED:
              leg.errorCode = Constants.LINE_CHANGED
              leg.errorMessage = this.translate('errors:' + Constants.LINE_CHANGED)
              break
            default:
              leg.errorMessage = null
              break
          }
          return leg
        })

        if (msgCode) {
          let msg = this.translate('errors:' + msgCode)
          AlertComponentAction.openAlert(msg, 'asia_betslip_alert')
        }
        
        asiaParlayTicket.legs = updatedLegs
        this.NewBetslipStore.updateAsiaParlayTicket(asiaParlayTicket)
      }
    })
  }

  static handleParlaysErrorResponse(response) {
    const { roundRobinOptionWithOdds, errorCode } = response;
    const asiaParlayTicket = JSON.parse(JSON.stringify(this.NewBetslipStore.asiaParlayTicket));
    let attention = {};
    const errorInfo = {
      popupErrorMessage: "Your bet has been rejected.",
      hasLineChanged: false
    };
    (roundRobinOptionWithOdds || []).forEach(rro => {
      const rroIndex = asiaParlayTicket.roundRobinOptions.findIndex(item => item.roundRobinOption === rro.roundRobinOption);
      if (rroIndex < 0) return;
      asiaParlayTicket.roundRobinOptions[rroIndex].odds = rro.odds;
      asiaParlayTicket.roundRobinOptions[rroIndex].unroundedDecimalOdds = rro.unroundedDecimalOdds;
    });
    switch (errorCode) {
      case Constants.BET_ERROR_CODE.INVALID_LEGS:
        this.updateParlayLegsInfo(response, asiaParlayTicket, errorInfo);
        if (!BetslipAction.isDisablePlaceBetBtn(asiaParlayTicket.legs) && errorInfo.hasLineChanged) {
          attention = {
            message: Constants.ATTENTION_MESSAGE.LINE_CHANGED,
            type: Constants.ATTENTION_TYPE.WARNING,
            display: 'left'
          };
        }
        break;
      case Constants.BET_ERROR_CODE.ROUND_ROBIN_DISALLOWED:
        asiaParlayTicket.legs.forEach(leg => leg.legStatus = Constants.BET_ERROR_CODE.ROUND_ROBIN_DISALLOWED);
        attention = {
          message: `errors:${Constants.BET_ERROR_CODE.ERROR3116}`,
          type: Constants.ATTENTION_TYPE.ERROR,
          display: 'left'
        };
        break;
      default:
        errorInfo.popupErrorMessage = errorCode;
        break;
    }
    this.NewBetslipStore.updateAsiaParlayTicket(asiaParlayTicket);
    if (!_.isEmpty(attention)) {
      this.NewBetslipStore.updateAttention(attention);
      return;
    }
    AlertComponentAction.openAlert(this.translate(`errors:${errorInfo.popupErrorMessage}`), 'asia_betslip_alert');
  }

  static updateParlayLegsInfo(response, asiaParlayTicket, errorInfo) {
    const { invalidLegs, validLegs } = response;
    if (_.isEmpty(invalidLegs)) return;
    invalidLegs.forEach(invalidLeg => {
      const legIndex = asiaParlayTicket.legs.findIndex(leg => leg.legId === invalidLeg.legId);
      if (legIndex < 0) return;
      switch (invalidLeg.errorCode) {
        case Constants.EVENT_OFFLINE:
        case Constants.INVALID_EVENT:
          asiaParlayTicket.legs[legIndex].errorCode = Constants.UNAVAILABLE;
          asiaParlayTicket.legs[legIndex].errorMessage = this.translate('errors:' + Constants.UNAVAILABLE_MESSAGE);
          break;
        case Constants.LINE_CHANGED:
          asiaParlayTicket.legs[legIndex].legStatus = Constants.ODDS_CHANGE;
          asiaParlayTicket.legs[legIndex].originalOdds = asiaParlayTicket.legs[legIndex].odds;
          asiaParlayTicket.legs[legIndex].odds = invalidLeg.price;
          errorInfo.hasLineChanged = true;
          break;
        case Constants.UNAVAILABLE:
          errorInfo.popupErrorMessage = Constants.UNAVAILABLE_MESSAGE;
          break;
        default:
          asiaParlayTicket.legs[legIndex].errorCode = invalidLeg.errorCode;
          break;
      }
    });
    (validLegs || []).forEach(item => {
      const legValidIndex = asiaParlayTicket.legs.findIndex(leg => leg.legId === item.legId);
      if (legValidIndex < 0) return;
      asiaParlayTicket.legs[legValidIndex].legStatus = item.status;
    });
  }

  static placeTeaserBet() {
    AlertComponentAction.closeAlert();
    this.NewBetslipStore.setLoading(true)

    const { teaserId, ticketId } = this.NewBetslipStore.asiaTeaserTicket
    const stake = BetslipAction.convertStakeToNumber(this.NewBetslipStore.asiaTeaserData.stake);
    const { oddsFormat } = this.SportsStore.options
    const winRiskStake = this.NewBetslipStore.getWinRiskOption;
    const payload = { teaserId, ticketId, oddsFormat, stake, winRiskStake, uniqueRequestId: BetslipAction.generateUUID() }

    BetslipAction.buyTeaserBetURL(JSON.stringify(payload), payload.uniqueRequestId).then(res => {
      this.NewBetslipStore.setLoading(false)
      if (!res) {
        let msg = this.translate('errors:INTERNAL_ERROR')
        AlertComponentAction.openAlert(msg, 'asia_betslip_alert teaser', true)
        return
      }

      const data = res.response;
      const errorCode = data[0].errorCode;

      if (errorCode) {
        let errorMessage
        const errData = res.errorMessage;
        if (errData) {
          errorMessage = this.translate('errors:' + errorCode, { 0: errData });
        } else {
          errorMessage = this.translate('errors:' + errorCode, { 0: "" });
        }

        if (errorCode === 'RESPONSIBLE_LIMIT_EXCEEDED_RISK' || errorCode === 'RESPONSIBLE_LIMIT_EXCEEDED_LOSS') {
          this.NewBetslipStore.updateAsiaTeaserData('stake', errorMessage)
        }

        AlertComponentAction.openAlert(errorMessage, 'asia_betslip_alert teaser', true)
        return
      }
      const dataRes = data[0];
      const status = dataRes.status;
      switch (status) {
        case 'ACCEPTED':
          this.handleTeaserSuccessResponse(dataRes)
          break
        case 'PROCESSED_WITH_ERROR':
          this.handleTeaserErrorResponse(dataRes)
          break
        default:
          break
      }
    })
  }

  static renderTeaserToastSuccess() {
    if(this.NewBetslipStore.isExpandBetSlip) return
    ToastGeneratorAction.generateToast({
      messages: [this.translate(Constants.TOAST.NEW_ACCEPTED_BET_MESSAGE)],
      className: Constants.TOAST.NEW_TOAST_CLASS_ACTIVE,
      isNewToast: true,
      toastStatus: Constants.TOAST.TOAST_CLASS_ACTIVE,
      matchInfo: [this.translate("BETS_SUCCESS")],
      selectionType: Constants.ASIA_BETSLIP_TYPES.TEASER
    })
  }

  static renderTeaserToastError(err) {
    ToastGeneratorAction.generateToast({
      messages: [this.translate(Constants.TOAST.NEW_UNACCEPTED_BET_MESSAGE)],
      className: Constants.TOAST.NEW_TOAST_CLASS_ERROR,
      isNewToast: true,
      toastStatus: Constants.TOAST.TOAST_CLASS_ERROR,
      matchInfo: [this.translate(err)],
      selectionType: Constants.ASIA_BETSLIP_TYPES.TEASER
    });
  }

  static handleTeaserSuccessResponse(dataRes) {
    const { betId, riskAmount, winAmount } = dataRes
    let teaserBetSuccessRes = JSON.parse(JSON.stringify(this.NewBetslipStore.asiaTeaserTicket))
    teaserBetSuccessRes = {
      ...teaserBetSuccessRes,
      betId,
      riskAmount,
      winAmount
    }
    this.NewBetslipStore.updateTeaserBetSuccessRes(teaserBetSuccessRes)
    this.NewBetslipStore.setAsiaTeaserSelections([]);
    this.NewBetslipStore.setAsiaTeaserReuseStake(riskAmount)
    this.NewBetslipStore.resetAsiaTeaserData()
    this.renderTeaserToastSuccess()
  }

  static handleTeaserErrorResponse(response) {
    const { invalidLegs } = response
    let asiaTeaserTicket = this.NewBetslipStore.asiaTeaserTicket
    let teaserErrorCode = 'Your bet has been rejected.'
    let changedLegs = [];

    if (invalidLegs && invalidLegs.length > 0) {
      invalidLegs.forEach((invalidLeg, leg) => {
        let matchedLeg = asiaTeaserTicket.legs.filter(l => l.legId === invalidLeg.legId)[0]

        switch (invalidLeg.errorCode) {
          case Constants.TEASER_ERROR.OFFLINE_EVENT:
          case Constants.TEASER_ERROR.INVALID_EVENT:
            matchedLeg.errorCode = Constants.TEASER_ERROR.EVENT_NOT_FOUND
            matchedLeg.errorMessage = this.translate('errors:' + Constants.UNAVAILABLE_MESSAGE)
            teaserErrorCode = Constants.TEASER_ERROR.OFFLINE_EVENT
            break

          case Constants.TEASER_ERROR.LINE_CHANGED:
            matchedLeg.errorCode = Constants.TEASER_ERROR.BET_LINE_CHANGED
            teaserErrorCode = Constants.TEASER_ERROR.BET_LINE_CHANGED
            changedLegs.push(
              {
                "legId": leg.legId,
                "lineId": leg.lineId,
                "point": leg.points,
                "pointStatus": Constants.TEASER_ERROR.POINT_CHANGE
              }
            );
            break

          case Constants.TEASER_ERROR.LINE_IS_NOT_AVAILABLE:
            matchedLeg.errorCode = Constants.TEASER_ERROR.LINE_IS_NOT_AVAILABLE
            teaserErrorCode = Constants.TEASER_ERROR.LINE_IS_NOT_AVAILABLE
            break

          default:
            matchedLeg.errorMessage = null
        }

        if (changedLegs.length > 0) {
          const { asiaTeaserSelections, asiaTeaserTicket } = this.NewBetslipStore
          let updatedTeaserSelections = asiaTeaserSelections
          let updatedTeaserTicket = asiaTeaserTicket
          const payloadLegs = asiaTeaserTicket.legs

          // update new selection id
          changedLegs.forEach((changedLeg, index) => {
            const payloadIndex = payloadLegs.findIndex((payload, index) => {
              return payload.legId === changedLeg.legId
            })

            if (payloadIndex > -1) {
              const selectionIndex = asiaTeaserSelections.findIndex((selection, index) => {
                return selection.selectionId === payloadLegs[payloadIndex].selectionId
              })
              if (selectionIndex > -1) {
                const newSelectionId = changedLeg.lineId + '|' + asiaTeaserSelections[selectionIndex].oddsId + '|' + asiaTeaserSelections[selectionIndex].teamType + '|' + changedLeg.point
                updatedTeaserSelections[selectionIndex].selectionId = newSelectionId
                let legs = payloadLegs
                legs[index].selectionId = newSelectionId
                updatedTeaserTicket.legs = legs
              }
            }
            this.NewBetslipStore.updateAsiaTeaserTicket(updatedTeaserTicket)
            this.NewBetslipStore.setAsiaTeaserSelections(updatedTeaserSelections)
          })

        }
      })
    }
    this.renderTeaserToastError('errors:' + teaserErrorCode)
  }

  static onChangeStake(value) {
    switch (this.NewBetslipStore.asiaActiveBetslip) {
      case Constants.ASIA_BETSLIP_TYPES.SINGLE:
      case Constants.ASIA_BETSLIP_TYPES.OUTRIGHT:
        this.onUpdateStakePerBet(value)
        break
      case Constants.ASIA_BETSLIP_TYPES.PARLAY:
        this.NewBetslipStore.setAsiaParlayData({ ...this.NewBetslipStore.asiaParlayData, stake: value })
        break
      case Constants.ASIA_BETSLIP_TYPES.TEASER:
        this.NewBetslipStore.setAsiaTeaserData({ ...this.NewBetslipStore.asiaTeaserData, stake: value })
        return
      default:
        return
    }
  }

  static onUpdateStakePerBet(stake){
    const { asiaNormalBetItem, asiaSingleInputs } = this.NewBetslipStore
    const newAsiaSingleInputs = {...asiaSingleInputs}

    for (let oddInput in newAsiaSingleInputs) {
      const bet = asiaNormalBetItem.find(bet => bet.oddsId === oddInput)
      newAsiaSingleInputs[oddInput] = this.calculateSingleInput(stake, bet.odds, bet.betType)
    }
    
    this.NewBetslipStore.updateNewAsiaSingleData('stakePerBet', stake)
    this.NewBetslipStore.updateSingleStakeInputs(newAsiaSingleInputs)
  }

  static initSingleDefaultStake(stakeInputs, bets, isInitSingleData) {

    const { defaultStake, enableDefaultStake, acceptBetterOdds } = this.SportsStore.options;
    const { asiaNormalBetItem } = this.NewBetslipStore;
    const listBetId = bets.map(bet => bet.oddsId)
    let currentStakeInputs = {}

    // Only keep current selection input to avoid incorrect summary info
    for(let key in stakeInputs) {
        if(listBetId.includes(key)) 
          currentStakeInputs[key] = stakeInputs[key]
    }

    if(!isInitSingleData) {
      // re-calculate maxPayout in case of odd changes
      const { oddsFormat } = this.SportsStore.options;
      const { winRiskOption } = this.NewBetslipStore;
      for(let bet of bets) {
        if(currentStakeInputs[bet.oddsId]) {
          const { stake } = currentStakeInputs[bet.oddsId]
          const { betType, odds } = bet
          currentStakeInputs[bet.oddsId].maxPayout = BetslipAction.getMaxpayout(stake, odds, oddsFormat, betType, winRiskOption)
        }
      }

      this.NewBetslipStore.updateSingleStakeInputs(currentStakeInputs);
      return
    }

    // Only init default sumary data when first selecting bet 
    if(!asiaNormalBetItem.length) {
      this.NewBetslipStore.updateNewAsiaSingleData('outRightAcceptBetterOdds', acceptBetterOdds);
      this.NewBetslipStore.updateNewAsiaSingleData('normalAcceptBetterOdds', acceptBetterOdds);
      this.NewBetslipStore.changeWinRiskOption(WinRiskType.BASE);
    }
    // Init new bet input if not exist before
    for (let bet of bets) {
      if (!currentStakeInputs[bet.oddsId]) {
        currentStakeInputs[bet.oddsId] = MbNewAsiaBetslipActions.initInputDefaultStake(enableDefaultStake, defaultStake, bet.betType, bet.odds);
      }
    }
    this.NewBetslipStore.updateSingleStakeInputs(currentStakeInputs);
  }

  static initInputDefaultStake(enableDefaultStake, defaultStake, betType, odds) {
    return enableDefaultStake && defaultStake ? 
      this.calculateSingleInput(defaultStake, odds, betType)
      : {
        stake: '',
        maxPayout: ''
      };
  }

  static calculateSingleInput(stake, odds, betType) {
    const { oddsFormat } = this.SportsStore.options;
    const { winRiskOption } = this.NewBetslipStore;
    return {
      stake: stake.toString(),
      maxPayout: BetslipAction.getMaxpayout(stake, odds, oddsFormat, betType, winRiskOption)
    }
  }

  static handleReuseSingleSelection(selectionId, isFromToast = false) {
    const { asiaNormalBetItem, reuseAsiaNormalBetItem, reuseAsiaSingleInputs, asiaSingleSelection, asiaSingleInputs } = this.NewBetslipStore;
    const { enableDefaultStake } = this.SportsStore.options
    const singleBets = isFromToast ? reuseAsiaNormalBetItem : asiaNormalBetItem
    const betItem = singleBets.find(item => item.selectionId === selectionId)
    if (!betItem) return;
    
    // Parse selection by selection type
    const selectionDetails = betItem.oddsSelectionsType === Constants.ODDS_SELECTION_TYPE.OUTRIGHT ?
      BetslipAction.parseSelectionIdWithContestantLineId(selectionId) :
      BetslipAction.parseSelectionIdWithAltLineId(selectionId);
    const selection = {
      selection: [selectionDetails.lineId, betItem.oddsId, selectionDetails.teamType].join("|"),
      id: betItem.oddsId,
      odds: betItem.odds,
      oddsSelectionsType: betItem.oddsSelectionsType,
    };

    !enableDefaultStake && this.NewBetslipStore.updateSingleStakeInputs({...asiaSingleInputs, [betItem.oddsId]: reuseAsiaSingleInputs[betItem.oddsId] });
    this.NewBetslipStore.reSelectSingleItem([selection, ...asiaSingleSelection ]);
    this.NewBetslipStore.updateAsiaNormalBetItem([]);
    this.NewBetslipStore.updateAsiaParlayTicket({});
    this.NewBetslipStore.updateAsiaActiveBetslip(Constants.ASIA_BETSLIP_TYPES.SINGLE);
    isFromToast && MbNewAsiaBetslipActions.clearReuseSingleSelectionToast(selectionId);
    this.handleExpandNewBetslip(true)
  }

  static handleReuseParlaySelection(acceptedBet, isFromToast = false) {
    const { parlayBetSuccessRes, reuseAsiaParlayBetItem, reuseAsiaParlayData } = this.NewBetslipStore
    const { legs } = isFromToast ? reuseAsiaParlayBetItem : parlayBetSuccessRes
    const stake = this.NewBetslipStore.initStakeReuse;
    const { enableDefaultStake } = this.SportsStore.options;
    const { selectedRoundRobins } = reuseAsiaParlayData
    this.NewBetslipStore.removeAllParlayData()
    if (!legs || !legs.length) return;
    legs.forEach(leg => {
      const selectionDetails = BetslipAction.parseSelectionIdWithoutAltLineId(leg.selectionId)
      const { lineId, eventId, period, betType, selectionType, isAlt, handicap, teamType } = selectionDetails;
      const oddsId = [eventId, period, betType, selectionType, isAlt, Number(handicap)].join('|');
      const selection = [lineId, oddsId, teamType].join('|')
      MbNewAsiaBetslipActions.addParlaySelection(oddsId, selection, leg.odds, leg.parlayRestriction, Constants.WAGER_TYPE.NORMAL)
    })
    this.handleExpandNewBetslip(true)
    this.NewBetslipStore.updateAsiaActiveBetslip(Constants.ASIA_BETSLIP_TYPES.PARLAY)
    isFromToast && this.NewBetslipStore.updateReuseAsiaParlayBetItem({})
    this.NewBetslipStore.updateAsiaParlayData('selectedRoundRobins', isFromToast ? [...selectedRoundRobins] : [acceptedBet.roundRobinOption])
    !enableDefaultStake && this.NewBetslipStore.updateAsiaParlayData('stake', stake)
  }

  static handleReuseTeaserSelection() {
    const { enableDefaultStake } = this.SportsStore.options;
    const { oddsReuseSelections, asiaTeaserReuseStake, asiaTeaserReuseSelections } = this.NewBetslipStore

    this.NewBetslipStore.removeAllTeaserData()
    this.handleExpandNewBetslip(true)
    this.NewBetslipStore.updateAsiaActiveBetslip(Constants.ASIA_BETSLIP_TYPES.TEASER)
    !enableDefaultStake && this.NewBetslipStore.updateAsiaTeaserData("stake", asiaTeaserReuseStake)
    this.NewBetslipStore.setAsiaTeaserSelections(asiaTeaserReuseSelections)
    this.NewBetslipStore.updateOddsSelections(oddsReuseSelections)
  }

  static renderSingleToast(selectionId, message, className, toastStatus, isFromPendingBet) {
    const {asiaNormalBetItem, reuseAsiaNormalBetItem, isExpandBetSlip} = this.NewBetslipStore
    if(isExpandBetSlip) return

    const singleBets = isFromPendingBet ? reuseAsiaNormalBetItem : asiaNormalBetItem
    const bet = singleBets.find(item => item.selectionId === selectionId)
    if(!bet) return

    const isOutright = bet.oddsSelectionsType === Constants.ODDS_SELECTION_TYPE.OUTRIGHT
    const teamNames = bet.homeTeam + ' vs ' + bet.awayTeam
    const moreInfo = !isOutright ? `${bet.betTypeDisp} (${Utils.getPeriodName(this.SportsStore.periodsDescription, bet.sportId, bet.periodNum, true)})` : ''
    const matchInfo = isOutright ? [this.translate('BETS_SUCCESS')] : [teamNames, moreInfo]
    
    ToastGeneratorAction.generateToast({
      messages: [this.translate(message)], 
      className,
      isNewToast: true,
      toastStatus,
      matchInfo, 
      selectionType: Constants.ASIA_BETSLIP_TYPES.SINGLE,
      id: selectionId
    })
  }

  static renderParlayToastSuccess() {
    if(this.NewBetslipStore.isExpandBetSlip) return
    ToastGeneratorAction.generateToast({
      messages: [this.translate(Constants.TOAST.NEW_ACCEPTED_BET_MESSAGE)],
      className: Constants.TOAST.NEW_TOAST_CLASS_ACTIVE,
      isNewToast: true, 
      toastStatus: Constants.TOAST.TOAST_CLASS_ACTIVE, 
      matchInfo: [this.translate('BETS_SUCCESS')], 
      selectionType: Constants.ASIA_BETSLIP_TYPES.PARLAY
    })
  }

  static renderParlayToastError(err) {
    ToastGeneratorAction.generateToast({
      messages: [this.translate(Constants.TOAST.NEW_UNACCEPTED_BET_MESSAGE)],
      className: Constants.TOAST.NEW_TOAST_CLASS_ERROR,
      isNewToast: true, 
      toastStatus: Constants.TOAST.TOAST_CLASS_ERROR, 
      matchInfo: [this.translate(err)],
      selectionType: Constants.ASIA_BETSLIP_TYPES.PARLAY
    })
  }

  static addParlaySelection(id, selection, odds, plRes, oddsSelectionsType) {
    let selections = Object.assign([], toJS(this.NewBetslipStore.asiaSingleSelection)).map(item => {
      return {
        ...item, legId: uuid()
      }
    });
    const existedIndex = selections.findIndex(sel => sel.id === id)
    if (existedIndex >= 0) {
      selections.splice(existedIndex, 1)
    }
    else {
      const eventId = id.split('|')[0];
      const isExistingEvents = _.find(this.NewBetslipStore.asiaSingleSelection, sel => sel.id.split('|')[0] == eventId);
      if (isExistingEvents) {
        // allow 2 leg on 1 event
        if (plRes == Constants.SUPPORT_PARLAY.ALLOWED_WITHOUT_RESTRICTIONS) {
          const tmp = _.filter(selections, sel => sel.id.split('|')[0] == eventId);
          const betType = id.split('|')[2];
          // remove the event has the same bet type
          const removeIdx = _.findIndex(tmp, sel => { return sel.id.split('|')[2] == betType; });
          if (removeIdx > -1) {
            selections = _.filter(selections, sel => sel.id !== tmp[removeIdx].id);
          }
        } else {
          selections = _.filter(selections, sel => sel.id.split('|')[0] !== eventId);
        }
      }

      selections.push({ id: id, legId: uuid(), selection: selection, odds: odds, parlayRestriction: plRes, oddsSelectionsType });
    }
    
    this.NewBetslipStore.setAsiaSingleSelection(selections);
  }

  static addTeaserSelection(teaserSelection) {
    const { asiaTeaserSelections, asiaTeaserTicket } = this.NewBetslipStore
    const { maxLegs } = asiaTeaserTicket
    const selections = Object.assign([], toJS(asiaTeaserSelections));
    const validSelections = selections.filter(sel => sel.id !== teaserSelection.id)
    const newSelections = validSelections.length < selections.length ? validSelections : [...selections, teaserSelection]

    if (maxLegs && newSelections.length > maxLegs) {
      const msg = this.translate('errors:' + Constants.TOAST.MAX_TEASERS)
      AlertComponentAction.openAlert(msg, 'asia_betslip_alert teaser', true)
      return
    }

    this.NewBetslipStore.setAsiaTeaserSelections(newSelections);
    this.NewBetslipStore.addOddsSelections(teaserSelection);
    this.NewBetslipStore.addOddsReuseSelections(teaserSelection);
    this.NewBetslipStore.setAsiaTeaserReuseSelections(newSelections);
  }

  static getIndexInArrayByNameAndValue(arr, idName, idValue) {
    return  _.findIndex(arr, item  => {return item[idName] === idValue });
  }

  static mergeTeaserSelection(oddsSelections, teaserTicket) {
    const { 
      teaserBetPayload,
      teaserBetItems
    } = this.NewBetslipStore;
    _.forEach(teaserTicket.legs, leg => {
      const legId = leg.legId;
      const payloadLegs = JSON.parse(teaserBetPayload.legs);
      const idx = this.getIndexInArrayByNameAndValue(payloadLegs, 'legId', legId);
      const selectionId = payloadLegs[idx].selectionId;
      const extraInfo = oddsSelections.reduce((filtered, selection) => {
        
        if (selection.selectionId === selectionId) {
          filtered.push({
            homeTeam: selection.homeTeam,
            awayTeam: selection.awayTeam,
            selectionType: selection.selectionType,
            leagueName: selection.leagueName,
            sportName: selection.sportName,
            teaserType: selection.teaserType,
            sportId: selection.sportId,
            selectionId: selection.selectionId,
            eventTeamType: selection.eventTeamType
          })
        }
        return filtered;
      }, [])
      if (extraInfo.length > 0) {
        Object.assign(leg, extraInfo[0]);
      }

      if (leg.pointStatus === Constants.TEASER_ERROR.POINT_CHANGE) {
        const indexPayload = BetslipAction.getIndexInArrayByNameAndValue(payloadLegs, 'legId', leg.legId);
        if (indexPayload > -1) {
          const indexSelection = BetslipAction.getIndexInArrayByNameAndValue(oddsSelections, 'selectionId', payloadLegs[indexPayload].selectionId);
          const newSelectionId = leg.lineId + '|' + oddsSelections[indexSelection].oddsId + '|' + oddsSelections[indexSelection].teamType + '|' + leg.point;
          this.NewBetslipStore.updateTeaserOddSelectionId(indexSelection, newSelectionId);
          this.NewBetslipStore.updateTeaserPayloadSelectionId(indexPayload, newSelectionId);
          Object.assign(leg, {errorCode: Constants.TEASER_ERROR.SELECTION_POINT_CHANGED});
        }
      }
      if (leg.errorCode === Constants.TEASER_ERROR.POINTS_NO_LONGER_AVAILABLE || leg.errorCode === Constants.TEASER_ERROR.EVENT_NOT_FOUND) {
        Object.assign(leg, {errorCode: Constants.TEASER_ERROR.EVENT_NOT_FOUND});
      }
    });
    if (!teaserTicket.maxLegs && !teaserTicket.minLegs) {
        const minMaxLegs = { 
        minLegs: teaserBetItems.minLegs,
        maxLegs: teaserBetItems.maxLegs,
        };
        Object.assign(teaserTicket, minMaxLegs);
    }
    this.NewBetslipStore.setTeaserBetItems(teaserTicket);
  }

  static convertDataFromSingleToParlay(selections) {
      return selections.map(sel => {
        sel.legId = uuid()
        return sel
      })
  }

  static convertDataFromParlayToSingle(selections) {
    return selections.map(sel => {
      sel.oddsSelectionsType = sel.oddsSelectionsType ? sel.oddsSelectionsType : Constants.WAGER_TYPE.NORMAL
      return sel
    })
  }

  static clearReuseSingleSelectionToast(selectionId) {
    const singleBets = this.NewBetslipStore.reuseAsiaNormalBetItem
    const index = singleBets.findIndex(sel => sel.selectionId === selectionId)
    if (index > -1) {
      singleBets.slice(index, 1)
      this.NewBetslipStore.updateReuseAsiaNormalBetItem(singleBets)
    }
  }

  static clearReuseSelectionToast(selectionType, selectionId) {
    switch (selectionType) {
      case Constants.ASIA_BETSLIP_TYPES.SINGLE:
        MbNewAsiaBetslipActions.clearReuseSingleSelectionToast(selectionId)
        break;
      case Constants.ASIA_BETSLIP_TYPES.PARLAY:
        this.NewBetslipStore.updateReuseAsiaParlayBetItem({})
        break; 
      default:
        break;
    }
  }

  static handleExpandNewBetslip(isExpand) {
    const { displayMaxBetWarning, newAsiaSingleData, parlayBetSuccessRes } = this.NewBetslipStore
    const { pendingBets } = newAsiaSingleData;
    this.NewBetslipStore.updateExpandBetSlip(isExpand)
    displayMaxBetWarning && this.NewBetslipStore.updateDisplayMaxBetWarning(false)
    if (pendingBets.length || (parlayBetSuccessRes.pendingBets && parlayBetSuccessRes.pendingBets.length)) {
      !isExpand ?
        ToastGeneratorAction.generateToast({
          messages: [this.translate(Constants.TOAST.NEW_PROCESSING_BET_MESSAGE)],
          className: Constants.TOAST.NEW_TOAST_CLASS_WARNING,
          isNewToast: true,
          toastStatus: Constants.TOAST.TOAST_CLASS_WARNING,
          disableTimer: true
        }) :
        window.fireEvent(EVENT.CLEAR_PENDING_BET_TOAST);
    }
  }

  static validateNewAsiaSingleBetItem(winRiskOption, betItems, stakeInputs) {
    let validationMessage
    let adjustInputs = {}
    for (let betItem of betItems) {
      const { maxStakeWin, maxStakeRisk, maxStakeBase, minStakeWin, minStakeRisk, minStakeBase, odds, oddsId, betType } = betItem
      const stake = stakeInputs[oddsId] ? stakeInputs[oddsId].stake : ''
      const convertedStake = BetslipAction.convertStakeToNumber(stake)

      if (!convertedStake) {
        continue
      }
      
      const minStake = BetslipAction.getStakeLimit(winRiskOption, minStakeWin, minStakeRisk, minStakeBase, odds)
      const maxStake = BetslipAction.getStakeLimit(winRiskOption, maxStakeWin, maxStakeRisk, maxStakeBase, odds)
      
      if (betItem.maxStake === 0 || maxStake === 0) {
        validationMessage = Constants.MAX_ZERO_MESSAGE;
      }
      else if (convertedStake < minStake) {
        validationMessage = validationMessage === Constants.INVALID_MAX_STAKE ? Constants.INVALID_MAX_MIN_STAKE : Constants.INVALID_MIN_STAKE
        adjustInputs[oddsId] = MbNewAsiaBetslipActions.calculateSingleInput(minStake, odds, betType)
      }
      else if (convertedStake > maxStake) {
        validationMessage = validationMessage === Constants.INVALID_MIN_STAKE ? Constants.INVALID_MAX_MIN_STAKE : Constants.INVALID_MAX_STAKE
        adjustInputs[oddsId] = MbNewAsiaBetslipActions.calculateSingleInput(maxStake, odds, betType)
      }
    }

    return {
      errorCode: validationMessage,
      adjustInputs
    }
  }

  static isDefaultAttention(attention) {
    return attention.message === Constants.ATTENTION_MESSAGE.ATTENTION;
  }

  static checkAttention() {
    const {
      asiaParlayTicket,
      asiaActiveBetslip,
      asiaNormalBetItem,
      attention
    } = this.NewBetslipStore;
    let isShowAttention = false;
    switch (asiaActiveBetslip) {
      case Constants.ASIA_BETSLIP_TYPES.SINGLE:
        isShowAttention = BetslipAction.isDisablePlaceBetBtn(asiaNormalBetItem);
        break;
      case Constants.ASIA_BETSLIP_TYPES.PARLAY:
        const legs = _.get(asiaParlayTicket, 'legs', []);
        isShowAttention = legs.length > 1 && BetslipAction.isDisablePlaceBetBtn(legs) || !this.isDefaultAttention(attention[asiaActiveBetslip]);
        break;
      default:
        break;
    }
    this.NewBetslipStore.updateShowAttention(isShowAttention);
  }

}


// WEBPACK FOOTER //
// ./src/app/components/BetslipComponent/AsiaView/MbNewAsiaBetslipActions.js